import { render, staticRenderFns } from "./ModalAddInvite.vue?vue&type=template&id=0c2a3ee3"
import script from "./ModalAddInvite.vue?vue&type=script&lang=js"
export * from "./ModalAddInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2a3ee3')) {
      api.createRecord('0c2a3ee3', component.options)
    } else {
      api.reload('0c2a3ee3', component.options)
    }
    module.hot.accept("./ModalAddInvite.vue?vue&type=template&id=0c2a3ee3", function () {
      api.rerender('0c2a3ee3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/components/Modals/ModalAddInvite.vue"
export default component.exports